import React, { useEffect,useState } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { Trans } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";

function UploadedProfilesDetails({
  uploadedProfiles,
  register,
  getValues,
  setValue,
  target,
}) {
  const { campaignID } = useParams();

  useEffect(() => {
    if (uploadedProfiles?.length > 0) {
      // setValue("uploadAge", true);
      // setValue("uploadLegal", true);
      setValue("uploadConsent", true);
    }
  }, [uploadedProfiles]);

  const [companyName,setCompanyName]= useState(null)
  useEffect(() => {
      const getCompanyName = async () => {
          try {
            let data = await axios.get(window.location.origin + "/jsv4/webapi/getCompanyLogo");
      
            if (data?.data?.status) {
              setCompanyName(data?.data?.companyName?.split(' ')[0]);
              console.log(data,"datatatata")
            } else {
              console.log("getCompanyLogo ", data?.data);
            }
          } catch (error) {
            console.log("Error in getCompanyLogo", error);
          }
        };
      getCompanyName();
  }, []);

  return (
    <>
      {uploadedProfiles?.length > 0 && (
        <>
          <div className="row pb-4">
            <div className="col">
              <div className="row my-2 justify-content-center">
                <div className="col-2">
                  <h6>
                    <Trans i18nKey="resumeNumber" defaults="Resume No" />
                  </h6>
                </div>
                <div className="col-4">
                  <h6>
                    <Trans i18nKey="fileName" defaults="File Name" />
                  </h6>
                </div>
                <div className="col-2">
                  <h6>
                    <Trans i18nKey="size" defaults="Size" />
                  </h6>
                </div>
              </div>
              {uploadedProfiles?.map((profile, index) => {
                let size = parseInt(profile.blobFile.size) / 1000;
                return (
                  <div
                    key={uuidv4()}
                    className="row my-2 justify-content-center"
                  >
                    <div className="col-2">{index + 1}</div>
                    <div className="col-4">{profile.name}</div>
                    <div className="col-2">
                      {size > 1024
                        ? Math.floor(size / 1000) + " Mb"
                        : Math.floor(size) + " Kb"}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className={`row justify-content-center mt-1 ${target && target == "autoschedule" ? "d-none" : ""}`}>
            <div className="col-xs-4 col-md-4 d-flex align-items-start justify-content-start">
              <span>
                <input
                  type="checkbox"
                  {...register("uploadAge", {
                    // required: false,
                  })}
                  // defaultChecked={getValues()?.uploadAge !== undefined ? getValues()?.uploadAge : false}
                />
              </span>
              <span className="ps-1">
                <Trans
                  i18nKey="youAreAtleast18YearsOfAge"
                  defaults="You are at least 18 years of age"
                />
                {"."}
              </span>
            </div>
          </div>
          <div className={`row justify-content-center mt-1 ${target && target == "autoschedule" ? "d-none" : ""}`}>
            <div className="col-xs-4 col-md-4 d-flex align-items-start justify-content-start">
              <span>
                <input
                  type="checkbox"
                  {...register("uploadLegal", {
                    // required: false,
                  })}
                  // defaultChecked={getValues()?.uploadLegal !== undefined ? getValues()?.uploadLegal : true}
                />
              </span>
              <span className="ps-1">
                <Trans
                  i18nKey="youAreLegallyAuthorizedToWorkInTheUS"
                  defaults="You are legally authorized to work in the US"
                />
                {"."}
              </span>
            </div>
          </div>
          <div className={`row justify-content-center ${target && target == "autoschedule" ? "d-none" : ""}`}>
            <div className="col-xs-4 col-md-4 d-flex align-items-start justify-content-start">
              <span>
                <input
                  type="checkbox"
                  {...register("uploadConsent", {
                    // required: false,
                  })}
                  defaultChecked={
                    getValues()?.uploadConsent !== undefined
                      ? getValues()?.uploadConsent
                      : true
                  }
                />
              </span>
              <span className="ps-1">
                {/* <Trans
                  i18nKey="youConsentToReceiveAlertsRegardingJobOpportunitiesFromTRC"
                  defaults="You consent to receive alerts regarding job opportunities from TRC"
                /> */}
                  <Trans
                    i18nKey="youConsentToReceiveAlertsRegardingJobOpportunitiesFrom"
                    defaults="You consent to receive alerts (Email or SMS or automated calls) regarding job opportunities from {{companyName}}"
                    values={
                   {
                    companyName: companyName,
                   }
                 }
                 />
                {". "}
                <a href="https://trctalent.com/privacy-policy/" target="_blank">
                  {" "}
                 PRIVACY POLICY ,
                </a>
                <a href="https://trctalent.com/terms-of-use/" target="_blank">
                  {" "}
                  TERMS AND CONDITIONS ,
                </a>
                <a href="https://trctalent.com/terms-of-use/" target="_blank">
                  {" "}
                 SMS Policy (MSG & Data Rates may apply).
                </a>{" "}
                .
                <span className="ms-1">
                  {companyName == "TRC" && (

                    <Trans
                      i18nKey="forHelpPleaseReachOuttoUSAt7703921411orprivacy@trctalentcomToUnsubscribeSendSTOP"
                      defaults="For help, please reach out to us at 7703921411 or <0>privacy@trctalent.com</0>. To unsubscribe, send STOP."
                      components={[
                        <a href="mailto:privacy@trctalent.com" target="_blank" />
                      ]}
                    />
                  )}
                </span>
              </span>
            </div>
          </div>
          <div className={`row justify-content-center mt-1 ${target && target == "autoschedule" ? "d-none" : ""}`}>
            <div className="col-xs-4 col-md-4 d-flex align-items-start justify-content-start">
              <span>
                <input
                  type="checkbox"
                  {...register("marketing", {
                    // required: false,
                  })}
                  // defaultChecked={getValues()?.uploadAge !== undefined ? getValues()?.uploadAge : true}
                />
              </span>
              <span className="ps-1">
                <Trans
                  i18nKey="iAgreeToReceiveMarketingCommunicationsFromTRCTalentSolutionsAboutJobOpportunities,CareerUpdates,AndHiringEvents.IUnderstandICanUnsubscribeAtAnyTime"
                  defaults="I agree to receive marketing communications from TRC Talent Solutions about job opportunities, career updates, and hiring events. I understand I can unsubscribe at any time"
                />
                {"."}
              </span>
            </div>
          </div>
        </>
      )}
    </>
  );
}

UploadedProfilesDetails.propTypes = {
  uploadedProfiles: PropTypes.array,
};

export default UploadedProfilesDetails;
